import { render, staticRenderFns } from "./wordbook.vue?vue&type=template&id=a4ae8d8e&scoped=true"
import script from "./wordbook.vue?vue&type=script&lang=js"
export * from "./wordbook.vue?vue&type=script&lang=js"
import style0 from "./wordbook.vue?vue&type=style&index=0&id=a4ae8d8e&prod&lang=scss&scoped=true"
import style1 from "./wordbook.vue?vue&type=style&index=1&id=a4ae8d8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ae8d8e",
  null
  
)

export default component.exports